import { getFitness21sDemonstrationPhase, type Fitness21sDemonstrationPhase } from '@/lib/fitness21sDemonstrationPhase';

export interface FitnessWalkingDemonstrationPhase {
  readonly protocol: 'walking-lunges';
  readonly kind: 'exercise' | 'reset';
  readonly start: number;
  readonly end: number;
  readonly demonstrationRep: null;
}
export type FitnessDemonstrationPhase = (Fitness21sDemonstrationPhase & { readonly protocol: '21s' }) | FitnessWalkingDemonstrationPhase;

/** Presentation from evaluated avatar time only. Seeking, pause, speed and loops
 * remain owned by the player. No workout counts, speech or persistence authority.
 * Walking V5 contract4925aaa4: two forward descents, then a visible four-step
 * reset11.2–16s. The endpoint remains reset; the player's next loop reports0.
 */
export function getFitnessDemonstrationPhase(
  exerciseId: string, currentTime: number, clipDuration: number,
): FitnessDemonstrationPhase | null {
  const phase21 = getFitness21sDemonstrationPhase(exerciseId, currentTime, clipDuration);
  if (phase21) return Object.freeze({ protocol: '21s', ...phase21 });
  if (exerciseId !== 'plan-walking-lunges' || !Number.isFinite(currentTime)
    || !Number.isFinite(clipDuration) || Math.abs(clipDuration - 16) > .0001
    || currentTime < 0 || currentTime > clipDuration + .0001) return null;
  const time = Math.min(currentTime, 16);
  return time < 11.2
    ? Object.freeze({ protocol: 'walking-lunges', kind: 'exercise', start: 0, end: 11.2, demonstrationRep: null })
    : Object.freeze({ protocol: 'walking-lunges', kind: 'reset', start: 11.2, end: 16, demonstrationRep: null });
}
